import React from 'react';

export const KudeNotificacionConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'funcionario'],
    routes  : [
        {
            path     : '/kude-notificacion/:id?/:id_det?',
            component: React.lazy(() => import('./KudeNotificacion'))
        }
    ]
};
